
















































































































































import SmsAccount from '@/types/SmsAccount.interface'
import CodeInput from '@/components/CodeInput.vue'
import OrganizationNameBubble from '@/components/OrganizationNameBubble.vue'
import Vue from 'vue'
import { WelcomeButton } from '@/types/components/Button.interface'
import Analytics from '@/services/Analytics'
import Role from '@/types/Role.interface'
interface WelcomeButtonToggle {
    disabled?: boolean
    textColor?: string
    width?: string
    buttons: WelcomeButton[]
}
interface WelcomeFooterComponent {
    name: string
    props?: any
}
interface WelcomeFooterLink {
    link?: string
    text: string
    callback?: Function
}
interface WelcomeTextInput {
    placeholder?: string
    path?: string
    paths?: string
    validate?: string
    name?: string
    appendIcon?: string
    warningMsg?: string
    callback?: Function
}
interface WelcomeItem {
    areaCode?: boolean
    img: string
    imgAlt: string
    imgWidth: string
    title: string
    subtitle?: string
    btnDisabled?: boolean
    btnText?: string
    buttons?: WelcomeButton[]
    buttonToggle?: WelcomeButtonToggle
    boldContent?: string
    arrayValues?: any[]
    arrayValueCallback?: Function
    textInput?: WelcomeTextInput
    textInputTooltip?: string
    skipBtn?: boolean
    footer?: string
    footerComponent?: WelcomeFooterComponent
    footerLink?: WelcomeFooterLink
}
interface OnboardingPayload {
    organization_name?: string
    number_type?: string
    broadcast_required?: string
    area_code?: number
    broadcast_size?: string
}
export default Vue.extend({
    components: {
        CodeInput,
        OrganizationNameBubble
    },
    data() {
        return {
            areaCode: null,
            broadcastRequired: null,
            broadcastSize: null,
            errorMessage: null,
            numberType: null,
            organizationName: null,
            selectedNumberType: false,
            step: 1,
            currentTeammate: null,
            teammates: [],
            volume: null
        }
    },
    computed: {
        isApp(): boolean {
            return this.$store.getters.isApp
        },
        invitationCount(): number {
            //  Grab our invitations from the store
            const invitations = this.$store.getters.teammatesInvitations

            //  If no invitations, return 0
            if (!invitations) return 0

            //  Else count the total
            return invitations.length
        },
        lastFooter(): string {
            //  Grab our number type
            const type = this.numberType

            //  Depending on this, return a different footer
            return (
                {
                    existingLandline:
                        'We just sent you an email regarding next steps on connecting your landline.<br><br>Follow the steps in the email for connecting an existing landline.',
                    multiple:
                        'We just sent you an email regarding next steps for setting up multiple phone numbers in MessageDesk.<br><br>Follow the steps in the email to setup multiple phone numbers.',
                    newLocal:
                        'We just sent you an email regarding next steps for choosing a specific phone number with a preferred area code.<br><br>Follow the steps in the email to request a local phone number.'
                }[type] ||
                'You can always request a new phone number in Settings -> Account Settings.'
            )
        },
        lastStepImg(): string {
            //  Check what our number type is
            const local = this.numberType === 'newLocal'

            //  If it is local, then return null
            if (local) return null
            //  Else, return an image
            return this.$images.noMessages
        },
        lastStepImgAlt(): string {
            //  Check what our number type is
            const local = this.numberType === 'newLocal'

            //  If it is local then return null
            if (local) return null
            //  Else, return our img alt text
            return 'Two People High Fiving'
        },
        lastStepTitle(): string {
            //  Check what our number type is
            const local = this.numberType === 'newLocal'

            //  If it is local, then return 'Choose an Area Code'
            if (local) return 'Choose an Area Code'
            //  Else, return our default
            return "Great! Now you're ready to send your first text"
        },
        lastStepSubtitle(): string {
            //  Check what our number type is
            const local = this.numberType === 'newLocal'

            //  If it is local, then return our subtitle for area codes
            if (local)
                return 'Let us know what 3-digit area code you want your phone number to start with'
            //  Else, return our default
            return 'Just navigate to the Inbox, create a contact and type your first message!'
        },
        smsAccount(): SmsAccount {
            return this.$store.getters.smsAccount
        },
        userCount(): number {
            return (
                this.$store.getters.userCount +
                this.invitationCount +
                this.teammates.length
            )
        },
        userLimit(): number {
            //  Grab our total number of users from our stripe plan
            return this.$store.getters.getLimit('user')
        },
        userLimitReached(): boolean {
            return this.userCount >= this.userLimit
        },
        userPrice(): number {
            //  Get the current product tier
            const tier = this.$store.getters.productTier

            //  If the tier is Team then return 15
            if (tier === 'Team') return 15

            //  Else, return 10
            return 10
        },
        welcomeItems(): WelcomeItem[] {
            return [
                {
                    img: this.$images.waveHand,
                    imgAlt: 'Hand Waving',
                    imgWidth: '120px',
                    title: 'Welcome to MessageDesk!',
                    subtitle:
                        'This is the name of your MessageDesk account. It will be used in Message Signatures and Opt-Out Messages',
                    buttons: [
                        {
                            text: 'Continue',
                            disabled: !this.organizationName,
                            color: 'primary',
                            textColor: 'white',
                            callback: () => this.nextStep()
                        }
                    ],
                    textInput: {
                        placeholder: "Your Organization's Name",
                        path: 'organizationName',
                        name: 'Organization Name'
                    },
                    textInputTooltip:
                        "<i>Don't Worry - You can edit this name at anytime</i>",
                    footerComponent: {
                        name: 'organization-name-bubble',
                        props: {
                            organizationName: this.organizationName
                        }
                    }
                },
                {
                    img: this.$images.appointmentReminder,
                    imgAlt: 'Conversations in the Inbox',
                    imgWidth: '220px',
                    title: 'Add Your Team',
                    subtitle:
                        'MessageDesk enables your team to all text from a single phone number in a shared inbox',
                    buttons: [
                        {
                            text: 'Continue',
                            disabled: !this.teammates.length,
                            color: 'primary',
                            textColor: 'white',
                            callback: () => this.onInvitationSend()
                        },
                        {
                            text: 'Skip Step',
                            color: 'white',
                            textColor: '#6142B0',
                            callback: () => this.nextStep()
                        }
                    ],
                    arrayValues: this.teammates,
                    arrayValueCallback: (teammate) => this.onTeammateRemoved(teammate),
                    textInput: {
                        placeholder: 'Teammates Email Address',
                        path: 'currentTeammate',
                        appendIcon: 'bi-plus-square-fill',
                        name: 'Teammates',
                        validate: 'email',
                        warningMsg:
                            this.userCount > this.userLimit
                                ? `You've exceeded the number of included seats on your plan. Additional seats are $${this.userPrice} per month`
                                : null,
                        callback: () => this.onTeammateAdded()
                    },
                    textInputTooltip:
                        '<i>Add an email and then press ENTER or Click the + button</i>',
                    footer: 'Not ready to add teammates yet?<br><br>We can remind you about this step later<br><br>',
                    footerLink: {
                        text: 'Remind Me Later',
                        callback: () => this.remindMeLater()
                    }
                },
                {
                    img: this.$images.oneToMany,
                    imgAlt: 'Too Much Stuff in the Inbox',
                    imgWidth: '120px',
                    title: 'Do You Need Broadcasts?',
                    subtitle:
                        'MessageDesk also enables you to reach multiple contacts at once with mass-text broadcast',
                    buttons: [
                        {
                            text: 'Yes',
                            color: 'primary',
                            textColor: 'white',
                            callback: () => this.onBroadcastSelected(true)
                        },
                        {
                            text: 'No',
                            color: '#e0e0e0',
                            textColor: '#6142B0',
                            callback: () => this.onBroadcastSelected(false)
                        },
                        {
                            text: "I'm Not Sure",
                            color: 'white',
                            textColor: '#6142B0',
                            callback: () => this.goToLastStep()
                        }
                    ],
                    footer: `To send Broadcasts you'll need to be on a specific subscription plan.<br><br>By answering the above questions, our team will reach out with more information.`
                },
                {
                    img: this.$images.oneToMany,
                    imgAlt: 'Too Much Stuff in the Inbox',
                    imgWidth: '120px',
                    title: 'How Many Contacts Are You Trying to Reach?',
                    subtitle:
                        'Select how many contacts you plan on reaching at once in MessageDesk',
                    buttonToggle: {
                        disabled: !this.broadcastSize,
                        width: '350px',
                        buttons: [
                            {
                                text: 'More than 1,000 contacts at once',
                                width: '350px',
                                callback: () => this.onThresholdSelected(1)
                            },
                            {
                                text: 'Between 100 and 1,000 contacts at once',
                                width: '350px',
                                callback: () => this.onThresholdSelected(2)
                            },
                            {
                                text: 'Less than 100 contacts at once',
                                width: '350px',
                                callback: () => this.onThresholdSelected(3)
                            },
                            {
                                text: "I'm Not Sure",
                                width: '350px',
                                callback: () => this.onThresholdSelected(4)
                            }
                        ]
                    },
                    footer: `To successfully send a Broadcast you may need to register your Phone Number with Carriers.<br><br>Our team can help you register correctly based on the number of contacts you plan to reach at once.`
                },
                {
                    img: this.$images.highFive,
                    imgAlt: 'Two People High Fiving',
                    imgWidth: '80px',
                    title: "Cheers! Here's a Temporary Number",
                    subtitle:
                        'You can use this temporary number during your 14-day free trial.',
                    boldContent: this.$options.filters.phone(this.smsAccount?.msisdn),
                    buttonToggle: {
                        width: '280px',
                        disabled: !this.numberType,
                        buttons: [
                            {
                                text: 'Keep Temporary Number',
                                width: '280px',
                                callback: () => this.nextStep()
                            },
                            {
                                text: 'Request New Local Phone Number',
                                width: '280px',
                                callback: () => this.onNumberSelection(1)
                            },
                            {
                                text: 'Connect an Existing Landline',
                                width: '280px',
                                callback: () => this.onNumberSelection(2)
                            },
                            {
                                text: 'Request Multiple Phone Lines',
                                width: '280px',
                                callback: () => this.onNumberSelection(3)
                            }
                        ]
                    }
                },
                {
                    img: this.lastStepImg,
                    imgAlt: this.lastStepImgAlt,
                    imgWidth: '220px',
                    areaCode: this.numberType === 'newLocal',
                    title: this.lastStepTitle,
                    subtitle: this.lastStepSubtitle,
                    buttons: [
                        {
                            text: "I'm Ready to Jump In",
                            color: 'primary',
                            textColor: 'white',
                            width: '280px',
                            hidden: this.numberType === 'newLocal',
                            callback: () => this.submit()
                        },
                        {
                            text: 'Request Area Code and Start Trial',
                            color: 'primary',
                            textColor: 'white',
                            width: '280px',
                            hidden: this.numberType !== 'newLocal',
                            callback: () => this.onAreaCodeSelected()
                        }
                    ],
                    footer: this.lastFooter
                }
            ]
        }
    },
    methods: {
        addUsers(): void {
            //  If our limit hasn't been reached, do nothing
            if (!this.userLimitReached) return

            //  Get our max number of users
            const limit = this.userLimit

            //  Get our current amount
            const curr = this.userCount

            //  Get the total we need to add by subtraction
            const needed = curr - limit

            //  Send an API request to update
            this.$store.dispatch('subscriptionChangeUsers', needed)
        },
        getInputValue(item: WelcomeTextInput): string {
            //  Grab our path
            const path = item.path

            //  Return the value from the vue instance
            return this[path]
        },
        goToLastStep(): void {
            //  Grab our last step (it's just the total length)
            const last = this.welcomeItems.length

            //  Go to the 2nd to last step (last step requires selection)
            this.step = last - 1
        },
        goToLink(link: string): void {
            window.open(link, this.isApp ? '_system' : '_blank')
        },
        handleFooterLink(item: WelcomeFooterLink): void {
            //  If there is a link, then go to it
            if (item.link) this.goToLink(item.link)
            //  Else, do our callback
            else item.callback()
        },
        nextStep(): void {
            //  Increment our step
            this.step++
        },
        onAreaCodeChange(val: number): void {
            this.areaCode = val
        },
        onAreaCodeSelected(): void {
            //  Check if the area code is valid (3 chars)
            const valid = this.areaCode.length === 3

            //  If it is valid, then we are done
            if (valid) this.submit()
            //  Else, set our error message
            else this.errorMessage = 'Please enter an area code'
        },
        onBroadcastSelected(required: boolean): void {
            //  Set our broadcast required data prop
            this.broadcastRequired = required

            //  If this was false, go to last step
            if (!required) return this.goToLastStep()

            //  Else, set our default broadcast size
            this.broadcastSize = 'More than 1000'

            //  If this was true, go to the next step
            this.nextStep()
        },
        onEnter(item: WelcomeTextInput): void {
            //  check if there is a callback
            const callback = item.callback

            //  If none, do nothing
            if (!callback) return

            //  Else, trigger it
            callback()
        },
        onInvitationSend(): void {
            //  Grab all of our teammates
            const emails = this.teammates

            //  Grab our roles
            const roles = this.$store.getters.roles

            //  Grab our operator role
            const operator = roles.find((x: Role) => x.name === 'Operator')

            //  Create an invitation for each of these
            for (let i = 0; i < emails.length; i++) {
                //  An invitation will be email and role
                let invitation = {
                    email: emails[i],
                    selectedRole: operator
                }

                //  Send an invitation
                this.$store.dispatch('invitationSend', invitation)
            }

            //  Add our users if needed
            //  This is no longer needed since we now handle this in our inviation accept
            // this.addUsers()

            //  Go to the next step
            this.nextStep()
        },
        onNumberSelection(val: number): void {
            //  Based on val we have a different number type
            const type =
                {
                    1: 'newLocal',
                    2: 'existingLandline',
                    3: 'mutliple'
                }[val] || null

            //  Set our type
            this.numberType = type
        },
        async onTeammateAdded(): Promise<void> {
            //  Grab current teammate
            const teammate = this.currentTeammate

            //  If nullish then do nothing
            if (!teammate) return

            //  Check our validator
            const valid = await this.$validator.validate()

            //  If it failed, do nothing
            if (!valid) return

            //  Add this to our list of teammates
            this.teammates.push(teammate)

            //  Set our current to null
            this.currentTeammate = null
        },
        onTeammateRemoved(val: string): void {
            //  Find the index of this teammate
            const idx = this.teammates.findIndex((x: string) => x === val)

            //  If idx is -1, do nothing
            if (idx === -1) return

            //  Else, splice them out
            this.teammates.splice(idx, 1)
        },
        onTextInput(val: string, item: WelcomeTextInput): void {
            //  Grab the value string
            const path = item.path

            //  Set this to our val
            this[path] = val
        },
        onThresholdSelected(val: number): void {
            //  Based on our val we have a different type
            const choice = {
                1: 'More than 1000',
                2: '100 to 1000',
                3: 'Less than 100 contacts',
                4: "I'm not sure"
            }[val]

            //  Keep track of this
            this.broadcastSize = choice
        },
        remindMeLater(): void {
            //  Report to segment
            Analytics.track('RemindLaterRequestTeammates')

            //  Go to the next step
            this.nextStep()
        },
        submit(): void {
            //  Create a payload
            const payload: OnboardingPayload = {
                organization_name: this.organizationName
            }

            //  @ts-ignore If we have a number type, include it
            if (this.numberType) payload.number_type = this.numberType

            //  @ts-ignore If we have broadcast requried, include it
            if (this.broadcastRequired)
                payload.broadcast_required = this.broadcastRequired

            //  If we have broadcast size, include it
            if (this.broadcastSize) payload.broadcast_size = this.broadcastSize

            //  @ts-ignore If we have an area code, include it
            if (this.areaCode) payload.area_code = this.areaCode

            //  Submit this to the parent
            this.$emit('submit', payload)
        }
    }
})
